import { useState } from "react";
import Link from "next/link";

import Tag from "ui-components/Tag";
import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";

import { createOptions } from "modules/data-files/create-options";
import { SelectSingleData } from "modules/data-files/elements/Data-File-Select";

const TransformData = () => {
  const [selected, setSelected] = useState<string>();
  const [selectedFile, setSelectedFile] = useState<string>();
  return (
    <div className="mx-auto mt-4 pt-4 max-w-screen-xl">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {createOptions.map((ins) => (
          <>
            {ins.active ? (
              <div key={ins.link} className="m-2 py-4 px-3 shadow bg-red-100">
                {ins.singleFile ? (
                  <div
                    onClick={() => setSelected(ins.link)}
                    className="cursor-pointer"
                  >
                    <p className="h4">{ins.title}</p>
                    <p>{ins.text}</p>
                  </div>
                ) : (
                  <Link href={`/transform-data/${ins.link}`}>
                    <a>
                      <p className="h4">{ins.title}</p>
                      <p>{ins.text}</p>
                    </a>
                  </Link>
                )}
              </div>
            ) : (
              <div key={ins.link} className="m-2 py-4 px-3 shadow bg-red-100">
                <div className="flex flex-wrap">
                  <Tag
                    className="-mt-6"
                    bgColorClass="bg-warning-main"
                    textColorClass="text-gray-900"
                  >
                    Coming Soon
                  </Tag>
                </div>

                <p className="h4">{ins.title}</p>
                <p>{ins.text}</p>
              </div>
            )}
          </>
        ))}
      </div>
      <Modal
        id="select-file"
        show={!!selected}
        handleClose={() => setSelected(undefined)}
        title={`Select Data File for ${
          createOptions.find((opt) => opt.link === selected)?.title
        }`}
      >
        <SelectSingleData selected={selectedFile} onChange={setSelectedFile} />
        <Divider />
        <p className="text-right">
          <Button color="gray" onClick={() => setSelected(undefined)}>
            Close
          </Button>
          {selected && (
            <Link href={`/transform-data/${selected}?data=${selectedFile}`}>
              <Button>
                Go to{" "}
                {createOptions.find((opt) => opt.link === selected)?.title}
              </Button>
            </Link>
          )}
        </p>
      </Modal>
    </div>
  );
};

export default TransformData;
